import React from "react";
import { Select } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import { OptionType } from "./StaticDropdown";
import { matchesDropdownSearch } from "src/Utils/dropdownSearch";

const { Option } = Select;

interface MultiSelectDropdownProps {
  valueList: string[];
  options: OptionType[];
  isDropDOwnDisabled?: boolean;
  handleChange: (val: string[]) => void;
}

const MultiSelectDropdownWithBox: React.FC<MultiSelectDropdownProps> = ({
  valueList,
  options,
  isDropDOwnDisabled = false,
  handleChange,
}) => {
  const [searchValue, setSearchValue] = React.useState("");
  const handleSearch = (value: string) => {
    setSearchValue(value);
  };

  const deleteTagHandler = (id: number | string) => {
    const newValueList = valueList.filter((item) => item !== id);
    handleChange(newValueList);
  };

  const getSelectedOptionTypes = () => {
    return options.filter((i) => valueList?.includes(i.value.toString()));
  };

  return (
    <div className="relative">
      <Select
        disabled={isDropDOwnDisabled}
        value={valueList}
        mode="multiple"
        showSearch
        allowClear
        onSearch={handleSearch}
        placeholder="صندوق ها"
        style={{ width: "100%" }}
        onChange={handleChange}
        filterOption={false}
        onClear={() => setSearchValue("")}
        tagRender={() => <></>}
      >
        {options
          .filter((option) => matchesDropdownSearch(option.label, searchValue))
          .map((option) => (
            <Option
              key={`${option.value} ${option.label}`}
              value={option.value}
            >
              <div className="flex flex-row justify-start items-center gap-2">
                <div>{option.label}</div>
              </div>
            </Option>
          ))}
      </Select>

      {valueList?.length > 0 && !searchValue && (
        <div className="absolute top-1.5 right-2 text-xs">
          {valueList.length} مورد انتخاب شده است
        </div>
      )}

      {valueList.length > 0 && (
        <div className="px-2 py-1 flex flex-row flex-wrap justify-start items-center gap-3 border-gray-300 rounded border-2 w-full max-h-20 overflow-y-auto mt-2">
          {getSelectedOptionTypes().map((item) => (
            <div
              key={item.value}
              className="p-1 flex flex-row justify-center items-center gap-2 text-xs bg-gray-100 border border-gray-300 rounded"
            >
              <div>{item.label}</div>
              <div
                className="text-sky-700 cursor-pointer pb-px"
                onClick={() => deleteTagHandler(item.value)}
              >
                <CloseCircleOutlined />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MultiSelectDropdownWithBox;
